import { type ValueOf } from '@direct-frontend/stdlib';
import { CONSTRUCTOR_LEFT_BAR_TAB_PAGE, CONSTRUCTOR_LEFT_BAR_TAB_SEARCH_PARAM_KEY } from '#entities/constructor';
import { ONBOARDING_KIT_STEPS, ONBOARDING_KIT_SUBTASKS } from '#shared/api/onboarding';
import {
    constructorRoute,
    designRoute,
    SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES,
    SETTINGS_LOGISTICS_SEARCH_PARAMS_WAREHOUSES,
    settingsAboutRoute,
    settingsDomainRoute,
    settingsIntegrationsRoute,
    settingsInventoryRoute,
    settingsLogisticsRoute,
    settingsPaymentRoute,
} from '#shared/lib/routes';
import { type OnboardingStepProps, type OnboardingSubtaskProps } from '../lib/types';

export const stepsProps: Record<ValueOf<typeof ONBOARDING_KIT_STEPS>, OnboardingStepProps> = {
    [ONBOARDING_KIT_STEPS.CHOOSE_DESIGN]: {
        href: designRoute.getUrl(),
        description:
            'Рекомендуем выбрать шаблон дизайна и перейти к загрузке товаров. Настроить вид магазина можно позже: при подключении доставки и оплаты',
    },
    [ONBOARDING_KIT_STEPS.ADD_PRODUCTS]: {
        href: settingsInventoryRoute.getUrl(),
        description: 'Добавьте товары, цены и остатки. Вы можете использовать один или несколько источников данных',
    },
    [ONBOARDING_KIT_STEPS.COMPANY_INFO]: {
        href: settingsAboutRoute.getUrl(),
        description: 'Проверьте ИНН и добавьте юридические документы',
    },
    [ONBOARDING_KIT_STEPS.DELIVERY_PAYMENT]: {
        href: settingsLogisticsRoute.getUrl({ searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_WAREHOUSES }),
        name: 'Подключите доставку, оплату и онлайн-кассу',
        description: 'Рекомендуем одновременно работать с видом вашего магазина: товарами, меню, шаблоном дизайна',
    },
    [ONBOARDING_KIT_STEPS.DOMAIN_INTEGRATIONS]: {
        href: settingsDomainRoute.getUrl(),
        name: 'Настройте домен и подключите Яндекс Метрику',
        description:
            'Перенос домена занимает до 3 дней. Подключите Яндекс Метрику сейчас, а после публикации магазина — другие интеграции',
    },
    [ONBOARDING_KIT_STEPS.PUBLISH]: {},
};

export const subtasksProps: Record<ValueOf<typeof ONBOARDING_KIT_SUBTASKS>, OnboardingSubtaskProps> = {
    [ONBOARDING_KIT_SUBTASKS.AUTH_AS_ORG]: {
        name: 'Проверить ИНН и заполнить описание компании',
        href: settingsAboutRoute.getUrl(),
        orderWithinStage: 0,
    },
    [ONBOARDING_KIT_SUBTASKS.LEGAL_DOCS_FILLED]: {
        href: constructorRoute.getUrl({}),
        search: `?${CONSTRUCTOR_LEFT_BAR_TAB_SEARCH_PARAM_KEY}=${CONSTRUCTOR_LEFT_BAR_TAB_PAGE}`,
        orderWithinStage: 1,
    },
    [ONBOARDING_KIT_SUBTASKS.SETUP_DELIVERY]: {
        href: settingsLogisticsRoute.getUrl({ searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES }),
        orderWithinStage: 0,
    },
    [ONBOARDING_KIT_SUBTASKS.SETUP_PAYMENT]: {
        name: 'Подключить оплату и онлайн-кассу',
        href: settingsPaymentRoute.getUrl(),
        orderWithinStage: 1,
    },
    [ONBOARDING_KIT_SUBTASKS.SETUP_DOMAIN]: {
        href: settingsDomainRoute.getUrl(),
        orderWithinStage: 0,
    },
    [ONBOARDING_KIT_SUBTASKS.SETUP_INTEGRATIONS]: {
        name: 'Подключить Яндекс Метрику',
        href: settingsIntegrationsRoute.getUrl(),
        orderWithinStage: 1,
    },
};
